<div 
  [innerHTML]="actualText" 
  (click)="toggleText()">
</div>
